import React, { FunctionComponent, ReactNode } from 'react'

const AudienceMetricCard = ({
  title,
  value,
  children,
  isLoading = false,
}: {
  title: string
  value: string
  children: ReactNode
  isLoading?: boolean
}): JSX.Element => {
  const icon = React.Children.toArray(children).find((child) => {
    if (React.isValidElement(child)) {
      // @ts-ignore
      return child?.type?.displayName === 'Icon'
    }
  })

  return (
    <div className={'p-5 border-2 rounded-lg flex flex-row items-center gap-3'}>
      <div>{icon}</div>
      <div className={'flex flex-col gap-2'}>
        <div className={'text-primary-xiketic text-sm font-bold'}>{title}</div>
        <div className={'text-primary-xiketic text-xl font-bold'}>
          {!isLoading ? value : '-'}
        </div>
      </div>
    </div>
  )
}

// eslint-disable-next-line react/display-name
AudienceMetricCard.Icon = ({ children }: { children: React.ReactNode }) => {
  return <div className={'flex justify-center items-center'}>{children}</div>
}
;(AudienceMetricCard.Icon as FunctionComponent).displayName = 'Icon'

export default AudienceMetricCard
